import { getAnalyticsAddon } from "owa-analytics-addons";
import type { AriaDatapointType } from "owa-analytics-types";

export function enrichDatapointWithAppVisibility(datapoint: AriaDatapointType, overwriteExisting: boolean = true): void {
    if (!overwriteExisting && datapoint.hasCustomData("appVisibility")) {
        return;
    }
    
    const addon = getAnalyticsAddon<void>("AppVisibilityEnrichment");
    if (addon.isRegistered) {
        addon.executeNow(datapoint);
    }
}
